import store from '@/store'

function findModuleByConfigKey(configKey) {
  const modulesBySlug = store.getters.modulesBySlug || {}

  if (!modulesBySlug || Object.keys(modulesBySlug).length === 0) {
    return null
  }

  for (const [moduleSlug, module] of Object.entries(modulesBySlug)) {
    if (module && module.config && module.config[configKey] !== undefined) {
      return moduleSlug
    }
  }

  return null
}

export function hasPermission(permissionName) {
  if (!permissionName) return true

  const user = store.getters.getAdminMe || store.getters.getUser
  if (!user) return false

  const userPermissions = user.permissions || []
  if (userPermissions.includes(permissionName)) {
    return true
  }

  const storePermissions = store.getters.userPermissions || []
  if (storePermissions.includes(permissionName)) {
    return true
  }

  const moduleSlug = findModuleByConfigKey(permissionName)
  if (moduleSlug) {
    const configValue = store.getters.getModuleConfig(moduleSlug, permissionName, null)
    if (configValue === true) {
      return true
    }
    if (configValue === false) {
      return false
    }
  }

  return false
}
